import React, { useState } from 'react';
import PropTypes from 'prop-types';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import { commaSeperator } from 'utils';
import classNames from 'classnames';

const ToggleLabel = ({ label, field, icon, className, dataTestid }) => {
  const [toggleLabel, setToggleLabel] = useState(false);
  return (
    <span
      className={classNames('toggle-label flex', className)}
      onMouseOver={() => setToggleLabel(true)}
      onMouseLeave={() => setToggleLabel(false)}
      data-testid={dataTestid}
    >
      <UiIcon icon={icon} />
      {toggleLabel === true && (
        <span className='toggle-label-title'> {label} : </span>
      )}
      <span className='toggle-label-number'>{commaSeperator(field) || 0}</span>
    </span>
  );
};

ToggleLabel.propTypes = {
  field: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  dataTestid: PropTypes.string,
};

export default ToggleLabel;
